export default __webpack_public_path__ + "./image/ff9767b246a2fb27f73c36ffceadbfdc.png";